import React,{useState, useCallback,useContext} from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import {authConfig} from '../auth/config';
import firebase from 'firebase/app';
import 'firebase/firestore'
import {withRouter} from 'react-router-dom';

import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  
}));

let listamenu=[""];
var listacao=[""];

//***************************************************carrega menu user */




//******************************************************************* */

export const FadeMenu=withRouter(({history}) => {
  const classes = useStyles();
  
  
  const [nrecados, setanrecados]=React.useState(0)
  const user = authConfig.auth().currentUser;

     const monitorrecado=()=>{
      var listarecado;
      
      var db2 = firebase.firestore();
            db2.collection("usuarios").doc(user.uid).collection("recados").where("statusrecado","==","novo")
            .onSnapshot((querySnapshot) => {
             
             
              var countrecados= 0
             

              querySnapshot.forEach((doc) => {
               
                  countrecados=countrecados+1;
                  
               
                });
                /*if(countrecados>0){
                  alert("Você tem "+countrecados+" Novo(s) Recado(s)");
                }*/
                setanrecados(countrecados);

               
          })
          
            
     }
     monitorrecado();

    
 
/*function pegarecados(){
  var db = firebase.firestore();
    var userrecado =  db.collection("usuarios").doc(user.uid).collection("recados").orderBy("datarecado", "desc")
     .get().then(function(querySnapshot) { 
         var countrecados= 0
      var listarecado='';
      setanrecados(0);
      querySnapshot.forEach(function(doc) {
       
        listarecado.push({recado:doc.data().recado, datarecado:doc.data().datarecado, statusrecado:doc.data().statusrecado})
        if(doc.data().statusrecado=="novo"){
          countrecados=countrecados++;
        }
      })
      setanrecados(countrecados);
      setalistarecados (currentArray => [...currentArray, listarecado]);
      
    }).catch(function(error) {
        alert("Erro ao procurar por recados ", error.message);
        })
       // monitorrecado();

      }
       

    //********************* */
    const handleClick = (event) => {
      history.push('/recados');
    };
  
         
  return (
    <div>

<IconButton  edge="start" aria-label="notifications" color="inherit" className={classes.menuButton} 
aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}>
              <Badge badgeContent={nrecados} color="secondary" >
                <NotificationsIcon />
              </Badge>
            </IconButton>
     
     
     
    </div>
  );
})
export default FadeMenu;